import { render, staticRenderFns } from "./globalSettings.vue?vue&type=template&id=15aa3da4&scoped=true&"
import script from "./globalSettings.vue?vue&type=script&lang=js&"
export * from "./globalSettings.vue?vue&type=script&lang=js&"
import style0 from "./globalSettings.vue?vue&type=style&index=0&id=15aa3da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa3da4",
  null
  
)

export default component.exports